// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum Roles {
	SuperAdmin = 1,
	Executor = 2,
	ComplianceOfficer = 3,
	ClientAdmin = 4,
}
